export const repRelationshipToBeneOptions = [
  {
    label: 'repRelationshipToBeneDropDown.beneficiary',
    value: 'Beneficiary'
  },
  {
    label: 'repRelationshipToBeneDropDown.parent',
    value: 'Parent of Minor Child'
  },
  {
    label: 'repRelationshipToBeneDropDown.legalGuardianRepPayee',
    value: 'Legal Guardian/ Rep Payee'
  },
  {
    label: 'repRelationshipToBeneDropDown.lawyer',
    value: 'Lawyer'
  },
  {
    label: 'repRelationshipToBeneDropDown.spouseRelativeFriend',
    value: 'Spouse/Relative/Friend'
  },
  {
    label: 'repRelationshipToBeneDropDown.federalCongressionalAgency',
    value: 'Federal/Congressional Agency'
  },
  {
    label: 'repRelationshipToBeneDropDown.stateInsuranceAgencies',
    value: 'State/Insurance Agencies'
  },
  {
    label: 'repRelationshipToBeneDropDown.providerSupplierPharmacist',
    value: 'Provider/Supplier/Pharmacist'
  },
  {
    label: 'repRelationshipToBeneDropDown.SHIP',
    value: 'SHIP'
  },
  {
    label: 'repRelationshipToBeneDropDown.seniorMedicarePatrolSMP',
    value: 'Senior Medicare Patrol (SMP)'
  },
  {
    label: 'repRelationshipToBeneDropDown.other',
    value: 'Other'
  }
]
